<template>
  <div class="camstudy-p2p row v-grid1" :class="isMobile ? 'p2p-video-main-mobile' : 'p2p-video-main'" data-grm-comp="RoomCallCamstudyP2P" ref="main" style="width: 100%; height: 100%;">
    <!--  attendance   -->
    <transition name="fade" mode="out-in">
      <CamStudyAttendance v-if="!isAttend(me.userId)" />
    </transition>
    <!--  stopwatch   -->
    <CallStopWatch />
    <!--  video   -->
    <div ref="subVideosWrapper" class="mobile-video-scroll">
      <div
       class="sub-videos-mobile"
       :class="roomUserCountStyle"
       ref="subVideos"
       :data-pip-mode="pip"
      >
        <RoomCallCamStudyP2PVideo class="main-video"
                                  :user="mainVideoUser"
                                  v-if="mainVideoUser.userId"
                                  @mounted="addSubVideosObserve"
        />
        <RoomCallCamStudyP2PVideo class="sub-video"
          v-for="(user, idx) in pinSubVideoUserList"
          :key="user.userId + '@' + user.screenShare"
          :user="user"
          :idx="idx"
          :defaultVideoObjectFit="'contain'"
          :pin="isPin(user.userId)"
          :isOpenUserControl="isOpenUserControl(user.userId)"
          @click="onSelectUserToggle"
          @onPinMode="onPinMode"
          @mounted="addSubVideosObserve"
          @destroyed="removeSubVideosObserve"

          :draggable="true"
          @dragstart.native="onVideoDragStart($event, user)"
          @dragenter.native="onVideoDragEnter($event, user)"
          @dragleave.native.prevent="onVideoDragLeave($event, user)"
          @drop.native.prevent.stop="onVideoDrop($event, user)"
          @dragover.native.prevent
        />
      </div>
    </div>
  </div>
</template>

<script>
import {Device} from "@/utils"
import {mapGetters} from "vuex";
import Vue from "vue"
// import RoomCallP2PVideo from "@/components/Room/Call/p2p/RoomCallP2PVideo.vue";
import RoomCallCamStudyP2PVideo from "@/components/Room/Call/p2p/RoomCallCamstudyP2PVideo.vue";
import CallStopWatch from "@/components/Room/Call/CallStopWatch.vue";
import CamStudyAttendance from "@/components/Room/Call/CamStudyAttendance.vue";

export default {
  name: "RoomCallCamStudyP2P",
  components: {CallStopWatch, RoomCallCamStudyP2PVideo, CamStudyAttendance},
  props: {
    pip: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mainVideoUser: {
        userId: null,
        screenShare: false
      },
      subVideoUserList: [],
      selectedVideoUser: null,
      pinUser: [],
    }
  },
  created: function(){
    console.log('call p2p main create : length[%d]',
        this.roomUserList.length);

    // window._c_list = window._c_list || [];
    // window._c_list.push(this);

    this.$roomApi.addEventListeners((this._Events = _Events()), this);

    // set roomUserList
    (() => {
      this.pinUser = JSON.parse(localStorage.getItem('grm_camstudy_pin')) || []
      // 필요한 정보객체 생성
      let userList = this.roomUserList.map(roomUser => {
        return {userId: roomUser.userId, screenShare: false, roomUser};
      });

      if(!this.pip){
        let myIdx = userList.findIndex(u => u.userId === this.me.userId);
        if(myIdx > -1){
          userList.splice(myIdx, 1);
        }
      }

      userList.sort((a,b) => {
        if(this.isMe(a.userId)){
          return -1;
        }else if(this.isMe(b.userId)){
          return 1;
        }

        if(a.screenStatus){
          return -1;
        }else if(b.screenShare){
          return 1;
        }
        return -1;
      });

      // add sub video
      this.addSubVideoUserList(userList);

      // pip 면 완료
      if(this.pip){
        return;
      }

      // screenShare mode
      if(this.isRoomMode('screenShare')){
        const user = userList.find(user => user.roomUser.screenStatus);
        if(user){
          this.setMainVideo({
            userId: user.userId,
            screenShare: true
          });
          return;
        }
      }

      this.setMainVideo({
        userId: this.me.userId
      });
    })();
  },
  destroyed() {
    this.$roomApi.removeEventListeners(this._Events);
    this.subVideoObserver?.disconnect();
  },
  computed: {
    ...mapGetters('room', ['isRoomMode']),
    ...mapGetters('user', [
      'me',
      'isMe',
      'getRoomUser',
      'roomUserList',
      'roomUserCount'
    ]),
    ...mapGetters('camstudy', ['isAttend']),
    isMobile() {
      return Device.isMobile();
    },
    pinSubVideoUserList(){
      return this.subVideoUserList.concat().sort((a,b) => {
        if(!this.pinUser.includes(a.userId) && this.pinUser.includes(b.userId)){
          return 1;
        }
        return -1;
      })
    },
    isPin(){
      return (userId) => {
        return this.pinUser.includes(userId);
      }
    },
    isOpenUserControl(){
      return (userId) => {
        return userId === this.selectedVideoUser;
      }
    },
    roomUserCountStyle(){
      return this.roomUserCount > 2 ? '' : 'layout-center'
    }
  },
  methods: {
    setMainVideo: function(roomUser){
      if(this.pip){
        return;
      }

      const currentUser = Object.assign({}, this.mainVideoUser);
      const {userId, screenShare} = roomUser;
      if(
        currentUser.userId === userId
        && currentUser.screenShare === screenShare
      ){
        return;
      }

      const idx = this.subVideoUserList.findIndex(user => {
        return user.userId === userId && user.screenShare === screenShare;
      });
      if(idx > -1){
        this.subVideoUserList.splice(idx, 1);
      }

      if(currentUser.userId){
        Object.assign(this.mainVideoUser, {userId: null, screenShare: null});
        this.addSubVideoUserList(currentUser);
      }
      Object.assign(this.mainVideoUser, {userId, screenShare, _createdAt: Date.now()});
      // console.log('@@@@ set main video :', this.mainVideoUser);
    },
    addSubVideoUserList: function(roomUser){
      if(Array.isArray(roomUser)){
        roomUser.forEach(ru => {
          this.addSubVideoUserList(ru);
        })
        return;
      }

      if(
        this.mainVideoUser
        && this.mainVideoUser.userId === roomUser.userId
        && !!this.mainVideoUser.screenShare === !!roomUser.screenShare
      ){
        return;
      }

      if(this.subVideoUserList.some(user => {
        return user.userId === roomUser.userId
            && !!user.screenShare === !!roomUser.screenShare;
      })){
        return;
      }
      this.subVideoUserList.push({
        userId: roomUser.userId,
        screenShare: !!roomUser.screenShare,
        _createdAt: Date.now()
      });
    },
    onPinMode: function(roomUser){
      // const list = this.subVideoUserList;
      // let idx = list.findIndex(ru => {
      //   return ru.userId === roomUser.userId
      //     && ru.screenShare === roomUser.screenShare;
      // });
      // if(idx > -1){
      //   list.splice(idx, 1);
      // }
      // list.unshift(roomUser);
      if(this.pinUser.includes(roomUser.userId)){
        let idx = this.pinUser.findIndex(ru => {
          return ru === roomUser.userId
        });
        if(idx > -1){
          this.pinUser.splice(idx, 1);
        }
      }else {
        this.pinUser.push(roomUser.userId);
      }
      localStorage.setItem('grm_camstudy_pin', JSON.stringify(this.pinUser));
    },
    onSelectUserToggle(userId){
      if(this.selectedVideoUser === userId){
        this.selectedVideoUser = null;
        return;
      }
      this.selectedVideoUser = userId;
    },
    removeVideo: function({userId, screenShare, all=false}){
      let idx = -1;
      while((idx=this.subVideoUserList.findIndex(ru => {
        if(!all && ru.screenShare !== screenShare){
          return false;
        }
        return ru.userId === userId;
      })) > -1){
        this.subVideoUserList.splice(idx, 1);
      }
    },
    addSubVideosObserve: function($roomCallVideo){
      if(!$roomCallVideo.$el){
        console.warn('$roomCallVideo.$el is null', $roomCallVideo);
        return;
      }

      if(!this.$refs.subVideos){
        console.warn('subVideos is null');
        return;
      }

      if(this.subVideoObserver?.isConnected){
        if(this.subVideoObserver.root && !this.subVideoObserver.root.isConnected){
          this.subVideoObserver.disconnect();
          this.subVideoObserver = null;
        }
      }

      if(!this.subVideoObserver){
        this.subVideoObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            // console.log('@@@ GrmDomIntersect : intersect[%s], ratio[%d]',
            //     entry.isIntersecting, entry.intersectionRatio, entry.target.__vue__.roomUser.nickname,
            //     entry.target, entry);
            entry.target.setAttribute('intersecting', entry.isIntersecting);
            entry.target.setAttribute('it-ratio', (entry.intersectionRatio*100).toFixed(2));
            const event = new Event('GrmDomIntersect');
            event.isIntersecting = entry.isIntersecting;
            event.intersectionRatio = entry.intersectionRatio;
            entry.target?.__vue__?.onRoomVideoResize(event, {immediate: this.pip && entry.isIntersecting});
          })
        }, {
          // root: this.$refs.subVideosWrapper,
          // root: this.$el,
          rootMargin: '0px',
          threshold: 0.3
        });
      }

      this.subVideoObserver.observe($roomCallVideo.$el);
    },
    removeSubVideosObserve: function($roomCallVideo){
      if(!this.subVideoObserver) return;
      if(!$roomCallVideo?.$el) return;
      this.subVideoObserver.unobserve($roomCallVideo?.$el);
    },
    setSubVideoVAD: function({userId, volume, avgVolumeSecond}){
      const VOLUME_LIMIT = 2;

      if(avgVolumeSecond !== undefined ){
        // 일정볼륨 보다 커야함
        if(avgVolumeSecond < VOLUME_LIMIT){
          return;
        }

        const list = this.subVideoUserList;

        // 현재 화자이면 return
        if(list[0].userId === userId || list.length <= 1){
          return;
        }

        // 첫번째 위치로 변경
        const idx = list.findIndex(user => user.userId===userId);
        if(idx > 0){
          // swap
          list.unshift(list.splice(idx, 1)[0])
        }
        return;
      }

      // 일정볼륨 보다 커야함
      if(volume < VOLUME_LIMIT){
        return;
      }

      const list = this.subVideoUserList;

      // 현재 화자이면 return
      if(list[0].userId === userId || list.length <= 1){
        return;
      }

      const vad = this._tmp_user_vad = this._tmp_user_vad || {};

      // 마지막 발언자가 아니면 새로 기록
      if(vad.userId !== userId){
        vad.userId = userId;
        vad.lastTime = Date.now();
        return;
      }

      // 1초 이하 발언 return
      if(Date.now()-(vad.lastTime || 0) < 500){
        return;
      }

      // 첫번째 위치로 변경
      const idx = list.findIndex(user => user.userId===userId);
      if(idx > 0){
        // swap
        list.unshift(list.splice(idx, 1)[0])
      }

    },

    // video drag and drop
    ...(function(){
      return {
        onVideoDragStart (e, user) {
          if(!user) return;

          const isCenter = (event, element) => {
            if(!element || !element.getBoundingClientRect) return false;
            const rect = element.getBoundingClientRect();

            const {clientX, clientY} = event.touches?.[0] || event;

            const offsetX = clientX - rect.left;
            const offsetY = clientY - rect.top;

            const xRatio = offsetX / rect.width;
            const yRatio = offsetY / rect.height;

            return xRatio >= 0.25 && xRatio <= 0.75 &&
                yRatio >= 0.25 && yRatio <= 0.75;
          };

          if(this.$Device.isMobile()){
            try{
              let chk = isCenter(e, e.currentTarget.querySelector('video') || e.currentTarget);
              if(!chk){
                e.preventDefault();
                return;
              }
            }catch(e){
              console.error(e);
            }
          }

          e.stopPropagation();
          e.dataTransfer.effectAllowed = 'move';
          e.dataTransfer.dropEffect = 'move';
          e.dataTransfer.setData('userid', user.userId);

          this.__video_drag_el = e.currentTarget;

          const img = new Image();
          img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmCxEDNCFmuQ4kAAAA+ElEQVRIx91TsQ2DMBB8QyqElEGyARVL0GUDChZgiUjMkBFoKA0dE6RMTY0Egr8UTkJEQmIjUJScZFkv///d+2yivwGumBtPwfr2YD8E3Ts1zf++B0CewxhS3uqFzlXMESaEEEREm3Gj28FUgamg1T24T6CrcHF8eo7gLAN2O+NG43cxXccMtC1wOIC32xUI+n7IqiogigBL39vPBF33/A/KEvA8ogeT54OZyLaHuCiI0pSorheaoGlUBrPagsBInx7B8QiEoco8nwHHMSaYMh1IEsCy1CpLNUUcGxBI+Z5g+KCA76vT0wm8WcDfV4J4vwe77irNX+ECtLmFUHd80+UAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjItMTEtMTdUMDM6NTI6MzMrMDA6MDCdGSqVAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIyLTExLTE3VDAzOjUyOjMzKzAwOjAw7ESSKQAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMi0xMS0xN1QwMzo1MjozMyswMDowMLtRs/YAAAAASUVORK5CYII=';
          e.dataTransfer.setDragImage(img, 0, 0);

          window.addEventListener('pointerup', event => {
            this.onVideoDrop(e);
          }, {once: true});
        },
        onVideoDragEnter (e, user) {
          if (!e.dataTransfer.types.includes('userid')) {
            return
          }
          // console.log('@@@@', e?.type, user.userId, e.currentTarget, e.target)
          e.preventDefault();
          e.stopPropagation();
          if(e.currentTarget !== this.__video_drag_el){
            e.currentTarget.setAttribute('drag-enter', 'true');
          }
        },
        onVideoDragLeave (e, user) {
          try{
            const {clientX, clientY} = e;
            if(clientX){
              const element = document.elementFromPoint(clientX, clientY);
              if(e.currentTarget.contains(element)){
                return;
              }
            }
          }catch(e){
            console.warn(e);
          }
          e.currentTarget.removeAttribute('drag-enter');
        },
        onVideoDrop (e, user) {
          e.currentTarget?.removeAttribute('drag-enter');
          this.__video_drag_el = null;

          let userId = e.dataTransfer?.getData('userid')
          if (!userId) {
            return
          }
          // console.log('@@ drop video:', user, userId)
          e.preventDefault();
          e.stopPropagation();

          const list = this.subVideoUserList;
          let srcIdx = list.findIndex(u => u.userId === userId);
          let targetIdx = list.findIndex(u => u.userId === user.userId);

          const srcUser = list.splice(srcIdx, 1)[0];
          list.splice(targetIdx, 0, srcUser);
        },
      }
    }())
  }
}
function _Events(){
  return {
    room_user_enter: function(e) {
      const roomUser = this.getRoomUser({userId: e.data.roomUser.userId});
      this.addSubVideoUserList(roomUser);
    },
    room_user_leave: function(e) {
      const { userId } = e.data;
      this.removeVideo({userId, all:true});
    },
    room_call_screenShare: function(e) {
      const start = e.data.screenShare;
      console.log('screen %s :', start ? 'start' : 'stop', e)

      if(start){
        this.setMainVideo({
          userId: e.data.userId,
          screenShare: true
        });
      }else{
        this.removeVideo({
          userId: e.data.targetUserId,
          screenShare: true
        })
      }
    },
    room_call_loadScreenShareStream: function(e) {
      this.setMainVideo({
        userId: this.me.userId,
        screenShare: true
      });
    },
    room_call_userMicVolume: function(e) {
      if(!this.pip){
        return;
      }

      this.setSubVideoVAD(e.data);
    },
  }
}
</script>

<style lang="scss">
.camstudy-p2p {
  .room-video {
    filter: contrast(1.1) brightness(1.1) saturate(1.1);
  }
  .grm-video {
    video {
      object-fit: cover;
    }
  }

  .main-video {
    //height: initial !important;
    //aspect-ratio: 1/1;
    pointer-events: auto;
  }
  .sub-video {
    //width: initial !important;
    aspect-ratio: 1/1;
  }
}
</style>
<style lang="scss" scoped>
@media(orientation: landscape){
  [grm-device-mobile] {
    .camstudy-p2p {
      padding: 0 env(safe-area-inset-right) 0 env(safe-area-inset-left);
    }
  }
}
.p2p-video-main {
  position: relative;
  .video-vip {
    .main-video {
      width: 100%;
      //height: 100%;
      height: unset;
      font-size: 0px;
    }
  }
}
.p2p-video-main-mobile {
  position: relative;
  .video-vip {
    .main-video {
      position: relative !important;
      //max-width: 100%;

      //@media (orientation: portrait) {
      //  &{
      //    height: calc(100vw/16*9);
      //    padding-top: 20%;
      //  }
      //}
      //@media (orientation: landscape) {
      //  & {
      //    //width: 100%;
      //    height: 60dvh;
      //  }
      //}
      font-size: 0px;
    }
  }
}

$sub-video-height: 100px;

[grm-device-mobile]{
  .mobile-video-scroll {
    @media(orientation: portrait) {
      height: calc(100dvh - 156px);
    }
    @media(orientation: landscape) {
      height: calc(100dvh - 100px);
      scroll-snap-type: y mandatory;
      -webkit-overflow-scrolling: touch;
    }
  }
}
html:not([grm-device-mobile]){
  .mobile-video-scroll {
    @media(orientation: landscape) {
      height: calc(100dvh - 150px - 80px);
    }
  }
}
.mobile-video-scroll{
  overflow: scroll;
  //@media (orientation: portrait) {
  //  &{
  //    height: calc(100% - 10% - 100vw/16*9);
  //  }
  //}
  //@media (orientation: landscape) {
  //  & {
  //    height: calc(40dvh - 50px);
  //  }
  //}
}
.mobile-video-scroll::-webkit-scrollbar {
  display: none;
}
.sub-videos-mobile {
  z-index: 2;
  display: flex;
  padding: 20px;
  &.layout-center{
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  width: 100%;
  text-align: right;
  pointer-events: none;
  background: transparent;
  max-width: 984px;
  margin: 0 auto;

  @media (orientation: portrait) {
    &{
      //height: calc(100% - 10% - 100vw/16*9);
      flex-wrap: wrap;
    }
    & {
      .sub-video {
        //width: 49.4%;
        //height: calc(44.0vw/1*1);
        //margin-bottom: 80px !important;
        //margin: 10px 10px !important;
      }
    }
  }
  @media (orientation: landscape) {
    & {
      //height: calc(40dvh - 50px);
      flex-wrap: wrap;
      .sub-video{
        flex-shrink: 0;
        width: calc((40dvh - 50px)/9*16);
      }
    }
  }
  //overflow: scroll !important;

  &[data-pip-mode="true"] {
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    padding: 0px;

    .sub-video {
      width: 100%;
      border: 0;
      cursor: default;
    }
  }
  .sub-video {
    pointer-events: auto;
    position: relative !important;
    display: inline-block;
    //border: 1px solid #747474;

    &:not(:first-child) {
      //margin-left: 4px !important;
      //border: 1px solid #747474;
    }

    video {
      width: auto;
      height: inherit;
    }
  }
}
.sub-videos {
  position: absolute;
  bottom: 2px;
  right: 2px;
  z-index: 2;
  width: 100%;
  height: $sub-video-height;
  text-align: right;
  pointer-events: none;
  background: transparent;
  overflow: hidden;
  //padding: 2px;

  &[data-pip-mode="true"] {
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    padding: 0px;

    .sub-video {
      width: 100%;
      border: 0;
      cursor: default;
    }
  }

  &:not([data-pip-mode="true"]) {
    .sub-video {
      width: 180px;
    }
  }
  .sub-video {
    pointer-events: auto;
    position: relative !important;
    display: inline-block;
    max-width: 180px;
    height: inherit;
    border: 1px solid #747474;

    &:not(:first-child) {
      margin-left: 4px !important;
      border: 1px solid #747474;
    }

    video {
      width: auto;
      height: inherit;
      object-fit: cover;
    }
  }
}
.room-extend-menu-component{
  .sub-videos{
    .sub-video{
      max-width: unset;
      cursor: default;
    }
  }
  .sub-videos-mobile{
    .sub-video{
      max-width: unset;
    }
  }
}

.sub-video {
  &[drag-enter="true"] {
    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 10;
      background-color: #ffffff50;
      left: 0;
      top: 0;
      border-radius: 10px;
    }
  }
}
</style>
